import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import {catchError, shareReplay, tap, retryWhen, take, scan, delay} from 'rxjs/operators';

import { HttpService } from '../http.service';
import { LpFundListItemReqRes } from 'src/app/lp/funds/LpFundListItemReqRes.model';
import { LpFundReqRes } from 'src/app/lp/funds/LpFundReqRes.model';
import HttpStatusCodesEnum from '../../shared/enums/HttpStatusCodesEnum';

@Injectable()
export class LpFundDataService {

  public readonly LP_FUNDS_BASE_ENDPOINT = 'lp/funds';

  constructor(
    private http: HttpService
  ) {
  }

  getLpFundsList(): Observable<LpFundListItemReqRes[]> {
    return this.http.getTyped<LpFundListItemReqRes[]>(this.LP_FUNDS_BASE_ENDPOINT).pipe(
      shareReplay(1),
      retryWhen(error =>
          error.pipe(
            tap(err => {
              if (err.status !== HttpStatusCodesEnum.REQUEST_TIMEOUT) {
                throw error;
              }
            }),
            scan((errorCount, err) => {
              if (errorCount > 3) {
                throw error;
              }
              return errorCount + 1;
            }, 1)
          )
        ),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  getById(id: number, basicInfo = false): Observable<LpFundReqRes> {
    let url = `${this.LP_FUNDS_BASE_ENDPOINT}/${id}`;
    if (basicInfo) {
      url += `?basicInfo=true`;
    }
    return this.http.getTyped<LpFundReqRes>(url).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  getPendingFunds(): Observable<LpFundListItemReqRes[]> {
    return this.http.getTyped<LpFundListItemReqRes[]>(`${this.LP_FUNDS_BASE_ENDPOINT}/pending`).pipe(
      shareReplay(1),
      retryWhen(error =>
        error.pipe(
          tap(err => {
            if (err.status !== HttpStatusCodesEnum.REQUEST_TIMEOUT) {
              throw error;
            }
          }),
          scan((errorCount, err) => {
            if (errorCount > 3) {
              throw error;
            }
            return errorCount + 1;
          }, 1)
        )
      ),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  getFundsOpportunities(): Observable<LpFundListItemReqRes[]> {
    return this.http.getTyped<LpFundListItemReqRes[]>(`${this.LP_FUNDS_BASE_ENDPOINT}/opportunities`).pipe(
      shareReplay(1),
      retryWhen(error =>
        error.pipe(
          tap(err => {
            if (err.status !== HttpStatusCodesEnum.REQUEST_TIMEOUT) {
              throw error;
            }
          }),
          scan((errorCount, err) => {
            if (errorCount > 3) {
              throw error;
            }
            return errorCount + 1;
          }, 1)
        )
      ),
      catchError(err => {
        return throwError(err);
      })
    );
  }
}
